import React from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import CashSessionInfoCard from '../../components/CashStatus/CashSessionInfoCard';
import CashSummaryCard from '../../components/CashStatus/CashSummaryCard';
import CashActionsCard from '../../components/CashStatus/CashActionsCard';

const CashStatusPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      {/* Contenido */}
      <div className="grid grid-cols-1 gap-6 pb-6 xl:grid-cols-3">
        <CashSessionInfoCard />
        <CashSummaryCard />
        <CashActionsCard />
      </div>
    </DefaultLayout>
  );
};

export default CashStatusPage;